import { MAX_WALLET_BANK_SCREEN_VIEWS } from 'containers/legal-reacceptance/constants';
import Logger from 'utils/logger';
import { remoteConfig } from 'utils/firebase';

const REMOTE_CONFIG_FETCH_TIMEOUT_MILLISECONDS = 10_000;
const REMOTE_CONFIG_MINIMUM_FETCH_INTERVAL_MILLISECONDS = 60_000;

export const RemoteConfigKeys = {
  walletBankScreenMaxShowCount: 'kWalletBankScreenMaxShowCount'
} as const;

const initializeRemoteConfigSettings = () => {
  remoteConfig.settings = {
    fetchTimeoutMillis: REMOTE_CONFIG_FETCH_TIMEOUT_MILLISECONDS,
    minimumFetchIntervalMillis: REMOTE_CONFIG_MINIMUM_FETCH_INTERVAL_MILLISECONDS
  };
};

const fetchAndActivateRemoteConfig = async () => {
  try {
    initializeRemoteConfigSettings();
    await remoteConfig.fetchAndActivate();
  } catch (error) {
    Logger.logException(error as Error, {
      module: 'remoteConfig',
      message: 'Failed to fetch and activate remote config'
    });
  }
};

const getRemoteConfigNumberValue = (key: string, fallbackValue: number): number => {
  const remoteConfigValue = remoteConfig.getValue(key).asString();
  const parsedRemoteConfigValue = Number(remoteConfigValue);
  if (Number.isNaN(parsedRemoteConfigValue) || parsedRemoteConfigValue <= 0) {
    return fallbackValue;
  }
  return parsedRemoteConfigValue;
};

export const getWalletBankScreenMaxShowCount = async (): Promise<number> => {
  await fetchAndActivateRemoteConfig();
  return getRemoteConfigNumberValue(RemoteConfigKeys.walletBankScreenMaxShowCount, MAX_WALLET_BANK_SCREEN_VIEWS);
};
